import { showRequestError } from '../utils/request-feedback';
import { PermissionContext } from "../permissions/access";
import permissionRouteEntries from "../permissions/route-entries.json";
import { buildMenuItems, filterMenuItems } from "../permissions/menu-order";
import React, { useEffect, useMemo, useState } from "react";
import {
    Route,
    HashRouter,
    Routes,
    useLocation,
    Navigate,
    useOutlet,
    matchRoutes,
} from "react-router-dom";
import {
    AppstoreOutlined,
    GlobalOutlined,
    CarryOutOutlined,
    BookOutlined,
    InstagramOutlined,
    HomeOutlined,
    CommentOutlined,
    UserSwitchOutlined,
    QuestionCircleOutlined,
    HighlightOutlined,
    TeamOutlined,
    UsergroupAddOutlined,
    TagsOutlined,
    DashboardOutlined,
    ControlOutlined,
    IssuesCloseOutlined,
    MessageOutlined,
    StarFilled,
    ProductOutlined,
    TrademarkCircleOutlined,
    SolutionOutlined,
    SnippetsOutlined,
    FlagOutlined,
    ReconciliationOutlined,
    HolderOutlined,
    ProfileOutlined,
    ReadOutlined,
    FileTextOutlined,
    WalletOutlined,
    DollarOutlined,
    BarsOutlined,
    VideoCameraOutlined,
    TagOutlined,
    ClusterOutlined,
    SettingOutlined,
    VideoCameraAddOutlined,
    LoadingOutlined,
    IdcardOutlined,
    LineChartOutlined,
    BugOutlined,
    QuestionOutlined,
    AuditOutlined,
    RiseOutlined,
    BranchesOutlined,
    OrderedListOutlined,
    CompassOutlined,
    GiftOutlined,
    ForkOutlined,
    GroupOutlined,
    RobotOutlined,
    FilterOutlined,
    FontSizeOutlined,
    NotificationOutlined,
    StarOutlined,
    AccountBookOutlined,
} from "@ant-design/icons";
import LoginPanel from "../screens/login";
import MainLayout from "../layout/mainlayout";
import { getCookie } from "../utils/cookie";
import KeepAlive from "keepalive-for-react";
import { Spin, Flex, Modal } from "antd";
import { fetchAdminInfo } from "../api/admin";
import NotAccessScreen from "../screens/login/not_access";
import { MainLayoutUrl } from "./router_path";

export const UserInfoProviderContext = React.createContext(null);

function getItem(label, key, icon, children, type) {
    let title = label;
    return {
        key,
        icon,
        children,
        label,
        title,
        type,
    };
}

export const menuItems = [
    getItem('Dashboard', 'dashboard', <DashboardOutlined />),
    getItem('Banners', 'banner', <AppstoreOutlined />),
    getItem('Homepage', 'homepage', <HomeOutlined />, [
        getItem('Hot Article', 'hotarticle', <SnippetsOutlined />),
        getItem('Hot Topic', 'hottag', <FlagOutlined />),
    ]),
    getItem('Discover', 'discover', <InstagramOutlined />, [
        getItem('Videos', 'videos', <VideoCameraOutlined />),
        getItem('Hot Bounty', 'hotbounty', <TagOutlined />),
        getItem('Hot Post', 'hotpost', <FileTextOutlined />),
        getItem('Hot Video', 'hotvideo', <VideoCameraAddOutlined />),
    ]),
    getItem('Daily', 'daily', <CarryOutOutlined />, [
        getItem('WiKi', 'knowledge', <HighlightOutlined />),
        getItem('Q&A', 'question', <QuestionCircleOutlined />),
        getItem('Insights', 'dailyinsights', <CompassOutlined />),
    ]),
    getItem('Learning', 'learning', <BookOutlined />, [
        getItem('Articles', 'learningarticles', <FileTextOutlined />),
        getItem('Courses', 'learningcourses', <BarsOutlined />),
        getItem('Course Category', 'coursecatalogs', <ForkOutlined />),
        getItem('Learning Center', 'learningcenter', <GroupOutlined />),
    ]),
    getItem('AI', 'ai', <RobotOutlined />, [
        getItem('Questions', 'aiquestions', <QuestionOutlined />),
        getItem('System Prompt', 'aisystemprompt', <FontSizeOutlined />),
        getItem('Stock Screener', 'aistockscreener', <FilterOutlined />),
        getItem('News Category', 'ainewscategory', <ForkOutlined />),
        getItem('News Articles', 'ainewsarticles', <ReadOutlined />),
        getItem('Article Notification', 'aiarticlenotification', <NotificationOutlined />),
        getItem('Investment Idea', 'aiinvestmentidea', <StarOutlined />),
    ]),
    getItem('Community', 'community', <CommentOutlined />, [
        getItem('Messaging', 'pushcampaigns', <NotificationOutlined />),
        getItem('Topic Tags', 'topictags', <HolderOutlined />),
        getItem('Content Tags', 'contenttags', <ProfileOutlined />),
        getItem('Approval', 'approvals', <AuditOutlined />, [
            getItem('Posts', 'pendingposts'),
            getItem('Articles', 'pendingarticles'),
            getItem('Comments', 'pendingcomments'),
        ]),
        getItem('Posts', 'post', <FileTextOutlined />, [
            getItem('Admin Posts', 'adminpost'),
            getItem('User Posts', 'userpost'),
        ]),
        getItem('Articles', 'article', <ReadOutlined />, [
            getItem('Admin Articles', 'adminarticle'),
            getItem('User Articles', 'userarticle'),
        ]),
        getItem('Comments', 'comment', <MessageOutlined />),
        getItem('Bounty Topic', 'bountytopic', <TagsOutlined />),
        getItem('Report Case', 'report', <IssuesCloseOutlined />),
        getItem('Crawled Posts', 'crawled', <BugOutlined />),
    ]),
    getItem('Private Market', 'privatemarket', <RiseOutlined />, [
        getItem('Asset Class', 'assetclass', <BranchesOutlined />),
        getItem('Products', 'privateproducts', <ProductOutlined />),
        getItem('Top Picks', 'toppicks', <OrderedListOutlined />),
        getItem('Recommended', 'recommendedforyou', <GiftOutlined />),
        getItem('Insights Cover', 'insightscover', <CompassOutlined />),
    ]),
    getItem('Users', 'users', <TeamOutlined />, [
        getItem('All Users', 'alluser', <UsergroupAddOutlined />),
        getItem('Recommended', 'recommenduser', <UserSwitchOutlined />),
        getItem('Whitelist Users', 'whitelistuser', <SolutionOutlined />),
        getItem('Virtual Users', 'virtualuser', <IdcardOutlined />),
        getItem('User Tags', 'ulabels', <TagsOutlined />),
        getItem('Profiling Quiz', 'profilingquiz', <QuestionOutlined />),
    ]),
    getItem('Task Center', 'points', <StarFilled />, [
        getItem('Point Overview', 'pointdata', <LineChartOutlined />),
        getItem('Products', 'products', <ProductOutlined />),
        getItem('Point Balance', 'balance', <TrademarkCircleOutlined />),
        getItem('Point Records', 'pointrecords', <ReconciliationOutlined />),
        getItem('Point Setting', 'pointsetting', <SettingOutlined />),
    ]),
    getItem('Crypto', 'crypto', <DollarOutlined />, [
        getItem('Wallet', 'wallet', <WalletOutlined />),
        getItem('Transactions', 'transactions', <BarsOutlined />),
    ]),
    getItem('Platform News', 'news', <GlobalOutlined />),
    getItem('System', 'system', <ControlOutlined />, [
        getItem('Subscription', 'subscription', <AccountBookOutlined />),
        getItem('Coupon Codes', 'couponcodes', <GiftOutlined />),
        getItem('Admins', 'admins', <UsergroupAddOutlined />),
        getItem('Roles', 'roles', <ClusterOutlined />),
        getItem('Permission', 'permissions', <SettingOutlined />),
        getItem('Login Logs', 'auditlogin', <AuditOutlined />),
        getItem('Operation Logs', 'auditoperation', <FileTextOutlined />),
        getItem('Config Setting', 'configsetting', <SettingOutlined />),
    ]),
];

export const getRoutes = () => {
    let routers = Object.keys(MainLayoutUrl).map(key1 => {
        if (Object.keys(MainLayoutUrl[key1]).includes('index')) {
            return Object.keys(MainLayoutUrl[key1]).map(key2 => {
                return {
                    path: MainLayoutUrl[key1][key2].path,
                    key: MainLayoutUrl[key1][key2].key ? MainLayoutUrl[key1][key2].key : MainLayoutUrl[key1][key2].selectedKey,
                    selectedKey: MainLayoutUrl[key1][key2].selectedKey,
                    exact: true,
                    element: MainLayoutUrl[key1][key2].element,
                    needCache: MainLayoutUrl[key1][key2].needCache ? MainLayoutUrl[key1][key2].needCache : false,
                }
            })
        }
        return Object.keys(MainLayoutUrl[key1]).map(key2 => {
            return Object.keys(MainLayoutUrl[key1][key2]).map(key3 => {
                return {
                    path: MainLayoutUrl[key1][key2][key3].path,
                    key: MainLayoutUrl[key1][key2][key3].key ? MainLayoutUrl[key1][key2][key3].key : MainLayoutUrl[key1][key2][key3].selectedKey,
                    selectedKey: MainLayoutUrl[key1][key2][key3].selectedKey,
                    exact: true,
                    element: MainLayoutUrl[key1][key2][key3].element,
                    needCache: MainLayoutUrl[key1][key2][key3].needCache ? MainLayoutUrl[key1][key2][key3].needCache : false,
                }
            });
        }).reduce((x, y) => [...(x ? x : []), ...y]);
    }).reduce((x, y) => [...(x ? x : []), ...y]);
    return routers;
}

const SystemRouters = () => {
    const [loaded, setLoaded] = useState(false);
    const [menusData, setMenusData] = useState([]);
    const [routesData, setRoutesData] = useState([]);
    const [userInfo, setUserInfo] = useState();

    useEffect(() => {
        let active = true;
        let sequence = 0;
        let lastPermissions = '';
        let lastNavigation = '';
        let refreshing = false;
        let refreshAgain = false;
        const refresh = async () => {
            // A slow identity request must be allowed to finish. Starting a new
            // poll every 15 seconds otherwise invalidates every previous result.
            if (refreshing) { refreshAgain = true; return; }
            refreshing = true;
            const request = ++sequence;
            if (!getCookie('user-token')) {
                if (active) { lastPermissions = ''; lastNavigation = ''; setUserInfo(null); setMenusData([]); setRoutesData([]); setLoaded(true); }
                refreshing = false;
                return;
            }
            try {
                const res = await fetchAdminInfo();
                if (!active || request !== sequence) return;
                if (!res) throw new Error('Permission information unavailable');
                // Permission lists are sets: transport ordering is not a grant change.
                const sorted = values => [...new Set(values || [])].sort();
                const info = { ...res, permission: {
                    all: res.permission?.all === true,
                    menus: sorted(res.permission?.menus),
                    btns: sorted(res.permission?.btns),
                    resources: sorted(res.permission?.resources),
                } };
                const snapshot = JSON.stringify({ identity: info.username, permission: info.permission });
                const menus = info.permission.menus;
                if (snapshot !== lastPermissions) {
                    if (lastPermissions) Modal.destroyAll();
                    lastPermissions = snapshot;
                    setRoutesData(getRoutes().filter(route => info.permission.all || menus.includes(permissionRouteEntries[route.path] || route.selectedKey)));
                }
                // Ordering is independent of grants: keep routes, dialogs and drafts mounted.
                const menuOrder = res.permission?.menuOrder || [];
                const menuTree = res.permission?.menuTree;
                const navigation = JSON.stringify({ snapshot, menuOrder, menuTree });
                if (navigation !== lastNavigation) {
                    lastNavigation = navigation;
                    const orderedMenus = buildMenuItems(menuItems, menuTree, menuOrder);
                    setMenusData(info.permission.all ? orderedMenus : filterMenuItems(orderedMenus, menus));
                }
                // Polling must not reactivate cached outlets when nothing changed.
                setUserInfo(current => JSON.stringify(current) === JSON.stringify(info) ? current : info);
            } catch (error) {
                if (active && request === sequence) showRequestError(error);
                const denied = [401, 403].includes(error.response?.status);
                if (active && request === sequence && (denied || !lastPermissions)) { lastPermissions = ''; lastNavigation = ''; Modal.destroyAll(); setUserInfo(null); setMenusData([]); setRoutesData([]); }
            } finally {
                if (active && request === sequence) setLoaded(true);
                refreshing = false;
                if (active && refreshAgain) { refreshAgain = false; refresh(); }
            }
        };
        const onFocus = () => { if (!document.hidden) refresh(); };
        const onSessionCleared = () => {
            ++sequence; // A pending identity response must not restore revoked access.
            lastPermissions = ''; lastNavigation = '';
            Modal.destroyAll();
            setUserInfo(null); setMenusData([]); setRoutesData([]); setLoaded(true);
        };
        refresh();
        const timer = setInterval(onFocus, 15000);
        window.addEventListener('focus', onFocus);
        window.addEventListener('admin-permissions-changed', refresh);
        window.addEventListener('admin-session-cleared', onSessionCleared);
        return () => { active = false; clearInterval(timer); window.removeEventListener('focus', onFocus); window.removeEventListener('admin-permissions-changed', refresh); window.removeEventListener('admin-session-cleared', onSessionCleared); };
    }, []);

    if (!loaded) {
        return (
            <Flex justify="center" align="center" style={{ height: '60vh' }}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} />} />
            </Flex>
        )
    }

    const firstMenuRoute = routesData.find(item => item.path === MainLayoutUrl.dashboard.index.path)?.path
        || routesData.find(item => !item.path?.includes(':'))?.path;
    // let notAccess = window.localStorage.getItem("_cachedGo") && !firstMenuRoute ? true : false;
    let notAccess = getCookie('user-token') && !firstMenuRoute ? true : false;

    return (
        <PermissionContext.Provider value={{ ...userInfo?.permission, username: userInfo?.username }}>
        <UserInfoProviderContext.Provider value={userInfo}>
            <HashRouter key={JSON.stringify({ identity: userInfo?.username, permission: userInfo?.permission })}>
                <Routes>
                    <Route
                        path="/login"
                        exact={true}
                        element={
                            <LoginRoute>
                                <LoginPanel />
                            </LoginRoute>
                        }
                    />
                    <Route
                        path="/notaccess"
                        exact={true}
                        element={firstMenuRoute ? <Navigate to={firstMenuRoute} replace /> : <NotAccessScreen />}
                    />
                    <Route path='/' element={<MainLayout menus={menusData} accountName={userInfo?.username} />}>
                        <Route path='/' element={<BasicLayoutWithCache fallbackPath={firstMenuRoute || '/notaccess'} />}>
                            {getRoutes().filter(route => !routesData.some(allowed => allowed.path === route.path)).map(route => (
                                <Route key={`denied:${route.path}`} path={route.path} element={<PrivateRoute><NotAccessScreen /></PrivateRoute>} />
                            ))}
                            {
                                routesData.map((route) => {
                                    return (
                                        <Route
                                            key={route.path}
                                            path={route.path}
                                            exact={route.exact}
                                            element={<PrivateRoute><PermissionContext.Provider value={{ ...userInfo?.permission, username: userInfo?.username, menu: route.selectedKey }}>{route.element}</PermissionContext.Provider></PrivateRoute>}
                                        />
                                    )
                                })
                            }
                        </Route>
                    </Route>
                    <Route
                        path="*"
                        element={<Navigate to={firstMenuRoute ? firstMenuRoute : (notAccess ? '/notaccess' : '/login')} replace={true} />}
                    />
                </Routes>
            </HashRouter>
        </UserInfoProviderContext.Provider>
        </PermissionContext.Provider>
    );
};

const LoginRoute = (props) => {
    const { children } = props;
    // const isLoggedIn = window.localStorage.getItem("_cachedGo") ? true : false;
    const isLoggedIn = getCookie("user-token") ? true : false;
    if (!isLoggedIn) {
        return <>{children}</>;
    }
    return <Navigate replace={true} to="/" />;
};

const PrivateRoute = (props) => {
    const { children } = props;
    // const isLoggedIn = window.localStorage.getItem("_cachedGo") ? true : false;
    const isLoggedIn = getCookie("user-token") ? true : false;
    const location = useLocation();
    if (isLoggedIn) {
        return <>{children}</>;
    }
    return (
        <Navigate
            replace={true}
            to="/login"
            state={{ from: `${location.pathname}${location.search}` }}
        />
    );
};

const BasicLayoutWithCache = ({ fallbackPath }) => {
    const outlet = useOutlet();
    const location = useLocation();

    const currRouter = useMemo(() => {
        // Use the same route ranking as <Routes>, including static and parameter segments.
        return matchRoutes(getRoutes(), location.pathname)?.[0]?.route;
    }, [location.pathname]);

    if (!currRouter) {
        return <Navigate to={fallbackPath} replace={true} />;
    }

    // Keep cached routes alive, but render noncached screens in the normal DOM.
    // The cache portal detaches/reinserts its active child on parent updates.
    const cache = Boolean(currRouter.needCache);
    return <div>
        <div hidden={!cache}>
            <KeepAlive activeName={cache ? permissionRouteEntries[currRouter.path] || currRouter.key : undefined} max={10} strategy={'LRU'}>
                {cache ? outlet : null}
            </KeepAlive>
        </div>
        {!cache && outlet}
    </div>;
}

export default SystemRouters;
